import { render, staticRenderFns } from "./ScratchPad.vue?vue&type=template&id=31d19bb4"
import script from "./ScratchPad.vue?vue&type=script&lang=js"
export * from "./ScratchPad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports